"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importDefault(require("@/constants"));
const ConfirmationDisconnectWalletModal = ({ walletName, onConfirm }) => {
    const onClose = () => {
        components_1.modalEvents.remove();
    };
    const handleOnConfirm = () => {
        onConfirm();
        onClose();
    };
    return (react_1.default.createElement(components_1.ModalTemplate, { title: constants_1.default.walletConnection.disconnectWallet, onClose: onClose, ariaLabel: constants_1.default.walletConnection.disconnectWallet, width: 630 },
        react_1.default.createElement("p", null, constants_1.default.walletConnection.areYouSure(walletName)),
        react_1.default.createElement(components_1.ModalTemplate.Footer, null,
            react_1.default.createElement(components_1.Button, { title: constants_1.default.general.cancel, variant: "secondary", onClick: onClose, ariaLabel: "cancel" }),
            react_1.default.createElement(components_1.Button, { title: constants_1.default.general.disconnect, variant: "error", onClick: handleOnConfirm, ariaLabel: "disconnect" }))));
};
exports.default = ConfirmationDisconnectWalletModal;
